import { Magnet, Globe, Lightbulb, Users, Target, TrendingUp, Palette, GraduationCap, BrainCircuit, Gem, BadgeDollarSign, Search, Megaphone, HeartHandshake } from 'lucide-react';

export const ICON_MAP = {
  'magnet': Magnet, 'globe': Globe, 'lightbulb': Lightbulb, 'users': Users,
  'target': Target, 'trending-up': TrendingUp, 'palette': Palette, 'graduation-cap': GraduationCap,
  'gem': Gem, 'badge-dollar': BadgeDollarSign, 'brain-circuit': BrainCircuit,
  'heart-handshake': HeartHandshake, 'search': Search, 'megaphone': Megaphone,
};

export const SERVICE_COLORS = {
  'svc-conseil': '#E9C46A',
  'svc-external': '#F4A261',
  'brand-solutions': '#0D9B8A',
  'svc-inbound': '#E63946',
  'svc-abm': '#264653',
  'svc-growth': '#6A4C93',
  'offres-pricing': '#D97706',
  'svc-formation': '#06D6A0',
  'ia-automatisation': '#7C3AED',
  'svc-design': '#E76F51',
  'svc-site': '#2A9D8F',
  'experience-client-crm': '#EC4899',
  'seo-geo': '#0EA5E9',
  'acquisition-digitale': '#F43F5E',
};

// Source unique de vérité pour les 14 services (ordre d'affichage)
export const SERVICES = [
  { id: 'svc-conseil', slug: 'conseil-consulting', title: 'Conseil & Consulting', short_desc: "Audit, stratégie et accompagnement marketing. CMO Part-time intégré à votre organisation.", icon: 'target', category: 'conseil' },
  { id: 'svc-external', slug: 'externalisation-delegation', title: 'Externalisation & Délégation', short_desc: "Déléguez tout ou partie de vos activités marketing à une équipe externe expérimentée.", icon: 'users', category: 'conseil' },
  { id: 'brand-solutions', slug: 'brand-solutions', title: 'Brand Solutions', short_desc: "Construisez une marque forte et différenciante avec nos solutions de branding complètes.", icon: 'gem', category: 'brand' },
  { id: 'svc-inbound', slug: 'inbound-marketing', title: 'Inbound Marketing', short_desc: "Attirez, convertissez et fidélisez vos prospects avec une stratégie de contenu ciblée.", icon: 'magnet', category: 'marketing' },
  { id: 'svc-abm', slug: 'account-based-marketing', title: 'Account-Based Marketing', short_desc: "Ciblez vos comptes stratégiques avec des campagnes ultra-personnalisées.", icon: 'target', category: 'marketing' },
  { id: 'svc-growth', slug: 'growth-marketing', title: 'Growth Marketing', short_desc: "Approche data-driven et expérimentale pour accélérer votre croissance.", icon: 'trending-up', category: 'marketing' },
  { id: 'offres-pricing', slug: 'offres-pricing', title: "Marketing de l'Offre et Pricing", short_desc: "Structurez vos offres et optimisez votre pricing pour développer vos ventes, en concertation avec vos directions.", icon: 'badge-dollar', category: 'conseil' },
  { id: 'svc-formation', slug: 'formations-accompagnement', title: 'Formations et Accompagnement', short_desc: "Montez en compétences sur le marketing digital et l'IA avec nos formations pratiques.", icon: 'graduation-cap', category: 'conseil' },
  { id: 'ia-automatisation', slug: 'ia-automatisation', title: 'IA & Automatisation', short_desc: "Boostez vos performances avec l'intelligence artificielle et l'automatisation marketing.", icon: 'brain-circuit', category: 'digital' },
  { id: 'svc-design', slug: 'design-studio', title: 'Design Studio', short_desc: "Direction artistique, design corporate et luxe, supports print et digital.", icon: 'palette', category: 'brand' },
  { id: 'svc-site', slug: 'creation-de-site', title: 'Création de Site', short_desc: "Sites vitrines et e-commerce performants, optimisés pour la conversion.", icon: 'globe', category: 'digital' },
  { id: 'experience-client-crm', slug: 'experience-client-crm', title: 'Expérience Client & CRM', short_desc: "Optimisez vos parcours clients et déployez une stratégie CRM performante pour fidéliser et convertir.", icon: 'heart-handshake', category: 'conseil' },
  { id: 'seo-geo', slug: 'seo-geo', title: 'SEO / GEO', short_desc: "Dominez les résultats de recherche classiques et génératifs pour capter le trafic qualifié.", icon: 'search', category: 'marketing' },
  { id: 'acquisition-digitale', slug: 'acquisition-digitale', title: 'Acquisition Digitale', short_desc: "SEA, Social Ads, Display : pilotez vos campagnes d'acquisition pour maximiser votre ROI.", icon: 'megaphone', category: 'marketing' },
];

export const SERVICES_ORDER = SERVICES.map(s => s.id);

export const SERVICE_CATEGORY_MAP = Object.fromEntries(SERVICES.map(s => [s.id, s.category]));

export const SERVICE_CATEGORIES = [
  { key: 'all', label: 'Tous' },
  { key: 'marketing', label: 'Marketing' },
  { key: 'conseil', label: 'Conseil & Stratégie' },
  { key: 'brand', label: 'Brand Solutions' },
  { key: 'digital', label: 'Digital & IA' },
];

// Lookup rapide par id
export const SERVICES_BY_ID = Object.fromEntries(SERVICES.map(s => [s.id, s]));

// Lookup rapide par slug
export const SERVICES_BY_SLUG = Object.fromEntries(SERVICES.map(s => [s.slug, s]));
